<template>
  <div class="section-200 position-relative">
    <ImgComparisonSlider :direction="direction" :handle-opacity="1" :handle-shadow="true"
                         class="slider-with-shadows slider-with-animated-handle">
      <!-- eslint-disable -->
      <figure slot="first" class="before">
        <img
            slot="first"
            class="w-100"
            :alt="findAttributeOnSiteInfo('site_name')[0]"
            :src="imageBefore"
        />
        <figcaption>{{ beforeText }}</figcaption>
      </figure>
      <figure slot="second" class="after">
        <img
            slot="second"
            class="w-100"
            :alt="findAttributeOnSiteInfo('site_name')[0]"
            :src="imageAfter"
        />
        <figcaption>{{ afterText }}</figcaption>
      </figure>
      <svg slot="handle" class="custom-animated-handle" xmlns="http://www.w3.org/2000/svg" width="100"
           viewBox="-8 -3 16 6">
        <path stroke="#fff" d="M -5 -2 L -7 0 L -5 2 M -5 -2 L -5 2 M 5 -2 L 7 0 L 5 2 M 5 -2 L 5 2" stroke-width="1"
              fill="#fff" vector-effect="non-scaling-stroke"></path>
      </svg>
      <!-- eslint-enable -->
    </ImgComparisonSlider>
  </div>
</template>

<script>
import mImg from "../Tags/Img";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {ImgComparisonSlider} from '@img-comparison-slider/vue';

export default {
  name: "Section200",
  components: {
    mImg,
    ImgComparisonSlider,
  },
  props: {
    imageBefore: {
      default: 'https://picsum.photos/1280/720'
    },
    imageAfter: {
      default: 'https://picsum.photos/1280/720'
    },
    direction: {
      default: 'horizontal',
      options: ['vertical', 'horizontal']
    },
    beforeText: {
      default: "قبل"
    },
    afterText: {
      default: "بعد"
    }
  },
  methods: {findAttributeOnSiteInfo},
  mounted() {
  }
}
</script>


<style scoped>
.before,
.after {
  margin: 0;
}

.before figcaption,
.after figcaption {
  background: #fff;
  border: 1px solid #c0c0c0;
  border-radius: 12px;
  color: #2e3452;
  opacity: 0.8;
  padding: 12px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  line-height: 100%;
}

.before figcaption {
  left: 16px;
}

.after figcaption {
  right: 16px;
}

.custom-animated-handle {
  transition: transform 0.2s;
}

.slider-with-animated-handle:hover .custom-animated-handle {
  transform: scale(1.2);
}

.slider-with-shadows {
  --default-handle-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  --divider-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}

img-comparison-slider {
  --divider-width: 5px;
  --divider-color: var(--primary);

}


</style>